/**
 * Rättar notislänkar som pekar på adresser utan route i appen.
 *
 * Ärendenotiser sparas i databasen med länken `/issues/{id}`, men appen har
 * ingen sådan route — Ärendehantering öppnar ett ärende via `/issues?issueId={id}`.
 * Rättningen görs när notisen öppnas, så att även notiser som redan ligger
 * i databasen leder rätt.
 *
 * @param {string|null|undefined} link
 * @returns {string|null|undefined}
 */
export function normaliseraNotisLank(link) {
  if (typeof link !== 'string') return link;
  const m = link.match(/^\/issues\/(\d+)\/?(?:[?#].*)?$/);
  if (m) return `/issues?issueId=${m[1]}`;
  return link;
}
